export default class Animate {
  constructor(map, option) {
    this.option = option || { frame: 20, delay: 2000 }
    this.map = map
    this.list = [] // 待执行动画列表
    return this
  }
  /**
   * 添加线性动画
   * @param {*} id
   * @param {*} name
   * @param {*} min
   * @param {*} max
   */
  putPaint(id, name, min = 0, max = 1) {
    let setProperty = (map, frame, step) => {
      let value = (max - min) / frame
      map.setPaintProperty(id, name, step * value)
    }
    this.list.push({ type: 'paint', setProperty })
    return this
  }
  /**
   * 位移动画
   * @param { } id
   * @param {*} name
   * @param {*} max
   */
  putTranslate(id, name, max = 10) {
    let setProperty = (map, frame, step) => {
      let value = (max - 0) / frame
      let offset = max - step * value
      map.setPaintProperty(id, name, [-offset, offset])
    }
    this.list.push({ type: 'translate', setProperty })
    return this
  }
  /**
   * 拔高初始动画
   * @param {*} id
   * @param {*} res
   * @param {*} key
   */
  putBuildHeight(id, res, k) {
    let ft = Object.assign({}, res)
    let maxs = []
    res.features.forEach(item => maxs.push(item.properties[k]))
    let setProperty = (map, frame, step) => {
      let i = 0
      let max = maxs[i]
      let value = max / frame
      if (step < frame) {
        ft.features[i].properties[k] = step * value
      } else {
        ft.features[i].properties[k] = item.properties[k]
      }
      // map.getSource(id).setData(res)
    }
    this.list.push({ type: 'buildHeight', setProperty })
    return this
  }
  putCustom(type, fn) {
    this.list.push({ type, fn })
  }
  /**
   * 绘制动画
   */
  start() {
    let step = 0
    let { frame, delay } = this.option
    let { map, list } = this
    // 动画执行
    function animate() {
      if (step < frame) {
        for (let item of list) {
          item.setProperty(map, frame, step)
        }
        step++
        requestAnimationFrame(animate)
      }
    }
    setTimeout(animate, delay)
  }
}



// WEBPACK FOOTER //
// ./src/framework/map/tool/animate.js